/**
 * The global texture layer: film grain + scanlines.
 *
 * Deliberately CSS-only. An animated canvas would burn a rAF loop and GPU upload every frame,
 * and the design system is explicit that visual FX must never compete with the audio thread —
 * the game is audio-first. So the grain is a tiled SVG-turbulence image whose background
 * position steps between a few offsets, and the scanlines are a repeating gradient that drifts
 * 3px. Both stop dead under `prefers-reduced-motion` or the in-app "off" setting.
 */
import { h } from '../dom.js';

let root: HTMLElement | null = null;

export function mountOverlay(): void {
  if (root) return;
  root = h(
    'div',
    { class: 'nb-overlay', 'aria-hidden': 'true' },
    h('div', { class: 'nb-grain' }),
    h('div', { class: 'nb-scanlines' }),
  );
  document.body.appendChild(root);
}

/** Re-evaluate after the OS preference or the in-app setting changes. */
export function refreshOverlay(): void {
  mountOverlay();
}
